import React from 'react';
import DepartmentForm from './DepartmentForm';
import Button from '@material-ui/core/Button';
import HelpLink from './HelpLink';
import Loading from 'components/pure/utils/Loading';
import confirm from 'utils/confirm';
import noop from 'lodash/noop';
import {Link} from 'react-router';
import 'styles/admin/DepartmentEditPage.styl';
import Breadcrumbs from 'components/pure/utils/Breadcrumbs';

const breadcrumbLinks = [
  {
    name: 'Departments',
    url: '/admin/departments',
  },
];

export default class DepartmentEditPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onDelete = this.onDelete.bind(this);
  }

  onDelete() {
    const {department} = this.props.DepartmentFormStore;
    confirm('Are you sure you want to delete this department?').then(
      () => this.props.DepartmentActions.deleteDepartment(department),
      noop
    );
  }

  render() {
    const {user} = this.props.AuthStore;
    const {department} = this.props.DepartmentFormStore;
    const teams = department ? this.props.TeamListStore.departmentTeams.get(department.id) : null;
    return (
      <div className="department-edit-page">
        <Breadcrumbs links={breadcrumbLinks} />
        <h1>Customize Department</h1>
        <HelpLink>
          <p>
            Customizations to Coach are made at the department level. All teams within a department
            share the same set of keywords and scorecards, and have the same archiving profile.
          </p>
          <p>Click on the links to modify attributes of this department.</p>
          <p>Click on the cog to manage profiles in the context of this department.</p>
        </HelpLink>
        {this.props.DepartmentFormStore.wasFetchError ? (
          'Error fetching department.'
        ) : this.props.DepartmentFormStore.isDepartmentLoading ? (
          <Loading />
        ) : (
          <DepartmentForm
            flags={user.flags}
            archivingProfiles={this.props.ArchivingProfileStore.archivingProfiles}
            filterWordsProfiles={this.props.FilterWordsProfileStore.filterWordsProfiles}
            cardProfiles={this.props.CardProfileStore.cardProfiles}
            stagingErrors={this.props.DepartmentFormStore.stagingErrors}
            toggledFields={this.props.DepartmentFormStore.toggledFields}
            department={department}
            stagingDepartment={this.props.DepartmentFormStore.stagingDepartment}
            isDepartmentSaving={this.props.DepartmentFormStore.isDepartmentSaving}
            updateDepartment={this.props.DepartmentActions.updateDepartment}
            {...this.props.DepartmentFormActions}
          />
        )}
        <div className="button-container">
          <Button
            component={Link}
            variant="contained"
            color="primary"
            className="ev-button"
            to="/admin/departments">
            View All Departments
          </Button>
          {teams && teams.size === 0 && (
            <Button variant="outlined" className="ev-button" onClick={this.onDelete}>
              Delete Department
            </Button>
          )}
        </div>
      </div>
    );
  }
}
